import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Grid } from "@mui/material";
import { useState } from "react";
import LoadingBackdrop from "../components/general/LoadingBackdrop";
import ReusableButton from "../components/general/ReusableButton";
import IjhsAutoDetectionPanel from "../components/Participant/IjhsAutoDetectionPanel";

export default function IjhsAutoDetection() {
  document.title = "IJHS Auto Detection";
  const [loading, setLoading] = useState(false);

  return (
    <Box className="wrapperBox">
      <LoadingBackdrop loading={loading} />
      <Grid
        className="firstRowContainer"
        container
        justifyContent="space-between"
      >
        <div className="dashboardAndSelfBtnDiv">
          <ReusableButton
            text="Dashboard"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            width={125}
            br={18}
            to="/dashboard"
            iconType="home"
          />
          <ChevronRightIcon />
          <ReusableButton
            text="IJHS Auto Detection"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            br={18}
          />
        </div>
      </Grid>
      <IjhsAutoDetectionPanel setLoading={setLoading} />
    </Box>
  );
}
